import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { FinanceDtoKeysEnum } from '@zaoblako/shared/modules/finance/enums/finance-dto-keys.enum';
import { nonEmptyStringSchema } from '@zaoblako/shared/modules/serde/schemas/non-empty-string.schema';

import * as yup from 'yup';

/** Planning scenario create and update APIs request body - DTO signature */
export interface PlanningScenarioFormInterface {
  /** Planning scenario display name */
  name: string;
  /** Planning scenario additional description */
  description?: string;
  /** Default planning scenario flag. Each tenant can have only one default planning scenario. */
  isDefault?: boolean;
  /** Planning scenario to use in BRS task analytics widget. Each tenant can have only one this planning scenario. */
  useInBrsTaskAnalytics?: boolean;
}

/** Planning scenario create and update APIs request body - DTO schema */
export const PlanningScenarioFormDto = SerdeDtoClass.create<PlanningScenarioFormInterface>(FinanceDtoKeysEnum.PLANNING_SCENARIO_FORM_DTO, {
  name: {
    sortable: true,
    label: 'Название',
    serializer: nonEmptyStringSchema,
  },
  description: {
    optional: true,
    label: 'Описание',
    serializer: yup.string(),
  },
  isDefault: {
    sortable: true,
    optional: true,
    label: 'Сценарий по-умолчанию',
    serializer: yup.boolean(),
  },
  useInBrsTaskAnalytics: {
    sortable: true,
    optional: true,
    label: 'Аналитика платежей',
    serializer: yup.boolean(),
  },
});
